import Img from "react-cloudimage-responsive";
import { useRouter } from "next/router";

function BackBlog() {
  const router = useRouter();

  return (
    <div
      style={{
        cursor: "pointer",
      }}
      onClick={() => {
        router.back();
      }}
    >
      <div
        key={"back_view"}
        style={{
          width: 15,
          height: 15,
          marginTop: 5,
          float: "left",
        }}
      >
        <Img
          className="border-radius"
          ratio={1 / 1}
          src={"icon-back3.png"}
          alt={"กีฬา"}
        ></Img>
      </div>
      <div style={{ width: 25, height: 25, float: "left" }}>
        <Img
          className="border-radius"
          ratio={1 / 1}
          src={"icon-tab-blogs.png"}
          alt={"กีฬา"}
        ></Img>
      </div>
      <h2 style={{ fontSize: 18 }}>บทความ</h2>
    </div>
  );
}
export default BackBlog;
